export default __webpack_public_path__ + "assets/images/cad2215388c9d0d0c257370e2474b457.png";